import ProgressiveImage from "react-progressive-image-loading"
import { ModalContent } from "./ModalContent"
import { FaAndroid, FaApple, FaDesktop, FaStar, FaGamepad, FaAd, FaClock, FaCheckCircle, FaMousePointer } from "react-icons/fa"
import { getOfferWallName, numberWithCommas } from "../../components/utils"
import { useEffect, useState } from "react"
import { socket } from "../../components/Containers/MainContainer"
import Skeleton from "react-loading-skeleton"
import QRCode from "react-qr-code"


export const PromotedOfferModalContent = (props) => {
    const [offerDetails, setofferDetails] = useState({})
    const [showQR, setShowQR] = useState(false);

    useEffect(() => {
    socket.on('offerDetails', (data) => {
        let steps = data.offer.steps;
        steps = steps.filter((x) => x != '')
        steps = steps.filter((x) => x != undefined)
        let osIn = [];
        if (data.offer.platforms == undefined ? '' : data.offer.platforms.includes("ios") || data.offer.platforms.includes("all") || data.offer.platforms.includes("apple")
            || data.offer.platforms.includes("iphone") || data.offer.platforms.includes("ipad") || data.offer.platforms.includes("*")) {
            osIn.push('ios')
        }
        if (data.offer.platforms.includes("android") || data.offer.platforms.includes("all") || data.offer.platforms.includes("*")) {
            osIn.push('android')
        }
        if (data.offer.platforms.includes("desktop") || data.offer.platforms.includes("all") || data.offer.platforms.includes("*") || data.offer.platforms.includes("windows") || data.offer.platforms.includes("window") || data.offer.platforms.includes("linux")
            || data.offer.platforms.includes("mac") || data.offer.platforms.includes("")) {
            osIn.push('window')
        }
        let uA = getOS();
        if (!osIn.includes(uA)) {
            setShowQR(true)
        }
        setofferDetails({ ...data.offer, steps })
        socket.off('offerDetails')
    })
    socket.emit('getOfferDetails', {
        offer: props.offer.offerId,
    })
    }, [])

    const getStatusIcon = (status) => {
        if (!status) return <FaClock />;
        const s = status.toLowerCase();
        if (s.includes('click') || s.includes('start')) return <FaMousePointer />;
        if (s.includes('complete') || s.includes('done')) return <FaCheckCircle />;
        return <FaClock />;
    };

    const getPopularityStars = (popularity) => {
        if (!popularity) return 0;
        const p = popularity.toLowerCase();
        if (p === 'very low') return 1;
        if (p === 'low') return 2;
        if (p === 'medium') return 3;
        if (p === 'high') return 4;
        if (p === 'very high') return 5;
        return 0;
    };

    return (
        <ModalContent
        click={props.click}
        title={props.offer.name}
        className="modal-content-promoted-offer"
        content={
            <>
                <div className="po-modal-body">
                    {/* Hero Section */}
                    <div className="po-hero">
                        <div className="po-hero-image">
                            <img src={props.offer.picture} alt={props.offer.name} />
                        </div>
                        <div className="po-hero-info">
                            <h2 className="po-hero-name">{props.offer.name}</h2>
                            <div className="po-hero-reward">
                                <ProgressiveImage
                                    preview="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                                    src="/assets/img/faucetify_coin_small.png"
                                    render={(src, style) => <img alt="coin" className="po-coin-icon" style={style} loading="lazy" src={src} />}
                                />
                                <span className="po-hero-reward-amount">{numberWithCommas(props.offer.reward)}</span>
                            </div>
                            <div className="po-hero-stars">
                                {offerDetails.popularity == undefined ? <Skeleton width={80} height={14} /> :
                                    [...Array(5)].map((_, i) => (
                                        <FaStar key={i} className={i < getPopularityStars(offerDetails.popularity) ? 'star-filled' : 'star-empty'} />
                                    ))
                                }
                            </div>
                        </div>
                        <div className="po-hero-platforms">
                            {props.offer.platforms.includes("android") || props.offer.platforms.includes("all") || props.offer.platforms.includes("*") ? <FaAndroid /> : ''}
                            {props.offer.platforms.includes("desktop") || props.offer.platforms.includes("all") || props.offer.platforms.includes("*") || props.offer.platforms.includes("windows") || props.offer.platforms.includes("window") || props.offer.platforms.includes("linux") || props.offer.platforms.includes("mac") || props.offer.platforms.includes("") ? <FaDesktop /> : ''}
                            {props.offer.platforms.includes("ios") || props.offer.platforms.includes("all") || props.offer.platforms.includes("apple") || props.offer.platforms.includes("iphone") || props.offer.platforms.includes("ipad") || props.offer.platforms.includes("*") ? <FaApple /> : ''}
                        </div>
                    </div>

                    {/* Info Tabs */}
                    <div className="po-info-tabs">
                        <div className="po-info-tab">
                            <div className="po-info-tab-icon">
                                {offerDetails.status == undefined ? <Skeleton width={20} height={20} circle /> : getStatusIcon(offerDetails.status)}
                            </div>
                            <span className="po-info-tab-value">{offerDetails.status == undefined ? <Skeleton width={60} height={12} /> : offerDetails.status}</span>
                            <span className="po-info-tab-label">Status</span>
                        </div>
                        <div className="po-info-tab-divider" />
                        <div className="po-info-tab">
                            <div className="po-info-tab-icon"><FaGamepad /></div>
                            <span className="po-info-tab-value">{offerDetails.category == undefined ? (props.offer.category || 'Offer') : offerDetails.category}</span>
                            <span className="po-info-tab-label">Category</span>
                        </div>
                        <div className="po-info-tab-divider" />
                        <div className="po-info-tab">
                            <div className="po-info-tab-icon">
                                {offerDetails.wall == undefined ? <Skeleton width={20} height={20} circle /> :
                                    <img src={`https://paidcash.co/assets/img/profile_small/${getOfferWallName(offerDetails.wall.split(' ').join('-')).toLowerCase()}.png`} alt="Provider" className="po-provider-icon" />
                                }
                            </div>
                            <span className="po-info-tab-value">{offerDetails.wall == undefined ? <Skeleton width={60} height={12} /> : getOfferWallName(offerDetails.wall.split(' ').join('-'))}</span>
                            <span className="po-info-tab-label">Provider</span>
                        </div>
                    </div>

                    {/* Rewards / Steps */}
                    <div className="po-section">
                        <h3 className="po-section-title">Rewards</h3>
                        <div className="po-rewards-list">
                            {offerDetails.steps == undefined ?
                                <Skeleton count={3} height={44} style={{ marginBottom: '8px', borderRadius: '8px' }} />
                                : offerDetails.steps.map((stepData, idx) => {
                                    let step = stepData.split('. Reward -->')
                                    return (
                                        <div key={idx} className="po-reward-row">
                                            {step[1] != undefined && (
                                                <div className="po-reward-badge">
                                                    <ProgressiveImage
                                                        preview="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                                                        src="/assets/img/faucetify_coin_small.png"
                                                        render={(src, style) => <img alt="coin" className="po-reward-coin" style={style} loading="lazy" src={src} />}
                                                    />
                                                    {numberWithCommas(step[1].split(' coins.').join('').split(' coin.').join('').trim())}
                                                </div>
                                            )}
                                            <div className="po-reward-text">{step[0].trim()}</div>
                                        </div>
                                    )
                                })}
                        </div>
                    </div>

                    {/* Description */}
                    {offerDetails.description && (
                        <div className="po-section">
                            <h3 className="po-section-title">Description</h3>
                            <p className="po-description-text">{offerDetails.description}</p>
                        </div>
                    )}

                    {/* QR Code */}
                    {showQR && (
                        <div className="po-section po-qr-section">
                            <h3 className="po-section-title">Scan to play</h3>
                            <div className="po-qr-container">
                                <QRCode value={`https://paidcash.co${window.location.pathname}`}
                                    style={{ background: '#fff', padding: '8px', width: '120px', height: '120px', borderRadius: '8px' }} />
                                <p className="po-qr-note">
                                    This offer is intended for {offerDetails.platforms == undefined ? <Skeleton width={30} height={10} /> : <>
                                        {offerDetails.platforms.includes("android") || offerDetails.platforms.includes("all") || offerDetails.platforms.includes("*") ? "Android " : ''}
                                        {offerDetails.platforms.includes("desktop") || offerDetails.platforms.includes("*") || offerDetails.platforms.includes("windows") || offerDetails.platforms.includes("window") || offerDetails.platforms.includes("linux") || offerDetails.platforms.includes("mac") || offerDetails.platforms.includes("all") || offerDetails.platforms.includes("") ? "Windows " : ''}
                                        {offerDetails.platforms.includes("ios") || offerDetails.platforms.includes("apple") || offerDetails.platforms.includes("iphone") || offerDetails.platforms.includes("all") || offerDetails.platforms.includes("ipad") || offerDetails.platforms.includes("*") ? "iOS " : ''}
                                    </>}
                                </p>
                            </div>
                        </div>
                    )}
                </div>

                {/* Start Offer Button */}
                {showQR || offerDetails.link == undefined ? '' :
                    <div className="po-start-btn" onClick={() => {
                        if (offerDetails.link != undefined) {
                            window.open(offerDetails.link, '_blank')
                        }
                    }}>
                        Start Offer
                    </div>
                }
            </>
        } />
    )
}
const getOS = () => {
    const ua = navigator.userAgent
    if (/android/i.test(ua)) {
        return "android"
    }
    else if ((/iPad|iPhone|iPod/.test(ua))
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        return "ios"
    }
    return "window"
}
